import PropTypes from 'prop-types';

import { ReactComponent as SearchIcon } from '../../../../resources/icons/search.svg';

import './search-input.scss';

const SearchInput = ({ searchString, onChange }) => {
  return (
    <div className="search-input">
      <input id="search" type="text" name="search" value={searchString} onChange={onChange} />
      <SearchIcon />
    </div>
  );
};

SearchInput.propTypes = {
  searchString: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SearchInput;
